'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var last = require('it-last');

var cid = require('multiformats/cid');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

function createAdd(_ref) {
  var addAll = _ref.addAll;
  return function (path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iter;
    var cid$1 = cid.CID.asCID(path);

    if (cid$1) {
      iter = addAll([_objectSpread({
        cid: cid$1
      }, options)], options);
    } else {
      iter = addAll([_objectSpread({
        path: path.toString()
      }, options)], options);
    }

    return last__default["default"](iter);
  };
}

exports.createAdd = createAdd;